<template>
  <div class="app-container" id="xmcheck">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="统计年份" prop="tjnf">
          <el-date-picker
            ref="tjnf"
            v-model="queryParams.tjnf"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="queryParams.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="queryParams.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="指标名称" prop="zbName">
          <el-input
            v-model="queryParams.zbName"
            placeholder="请输入指标名称"
            clearable
            size="small"
            style="width: 200px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="评价结果" prop="reviewResult">
          <el-select
            ref="reviewResult"
            v-model="queryParams.reviewResult"
            placeholder="评价结果"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in resultOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="handleQuery"
            :disabled="this.isnull"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            :disabled="this.isnull"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>

    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="loading"
        row-key="reviewId"
        :data="xmcheckList"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        v-if="xmcheckList && xmcheckList.length > 0"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="评价维度"
          align="left"
          prop="group"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="指标名称"
          align="left"
          prop="zbName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="指标类型"
          align="left"
          prop="type"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="自评" align="left" prop="zp" min-width="100px">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.zpDescribe }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.zp }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="非现场巡检"
          align="left"
          prop="fxcxj"
          min-width="100px"
        >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.fxcxjDescribe }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.fxcxj }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="现场巡检"
          align="left"
          prop="xcxj"
          min-width="100px"
        >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.xcxjDescribe }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.xcxj }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <div v-else><el-empty description="暂无数据"></el-empty></div>
      <!-- 修改参数配置对话框-->
      <el-dialog
        :title="title"
        :visible.sync="open"
        width="700px"
        append-to-body
        id="xmcheck-dialog"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
          <el-form-item label="评价维度">
            <el-input v-model="form.group" disabled="disabled"></el-input>
          </el-form-item>

          <el-form-item label="评价指标">
            <el-input v-model="form.zbName" disabled="disabled"></el-input>
          </el-form-item>

          <el-form-item label="指标类型">
            <el-input v-model="form.type" disabled="disabled"></el-input>
          </el-form-item>

          <el-form-item label="评价标准">
            <el-input
              type="textarea"
              autosize
              v-model="form.zbStandard"
              disabled="disabled"
            ></el-input>
          </el-form-item>

          <el-form-item label="自评">
            <el-select v-model="form.zp" placeholder="">
              <el-option
                v-for="item in resultOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="自评结果描述">
            <el-input
              type="textarea"
              maxlength="100"
              rows="5"
              show-word-limit
              v-model="form.zpDescribe"
            ></el-input>
          </el-form-item>

          <el-form-item label="非现场巡检">
            <el-select v-model="form.fxcxj" placeholder="">
              <el-option
                v-for="item in resultOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="非现场巡检结果描述">
            <el-input
              type="textarea"
              maxlength="100"
              rows="5"
              show-word-limit
              v-model="form.fxcxjDescribe"
            ></el-input>
          </el-form-item>

          <el-form-item label="现场巡检">
            <el-select v-model="form.xcxj" placeholder="">
              <el-option
                v-for="item in resultOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="现场巡检结果描述">
            <el-input
              type="textarea"
              maxlength="100"
              rows="5"
              show-word-limit
              v-model="form.xcxjDescribe"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注">
            <el-input
              type="textarea"
              maxlength="100"
              rows="5"
              show-word-limit
              v-model="form.bz"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getXmchecklist,
  getDictData,
  // getXmxxList,
  excelExport,
  getXmcheck,
  updateXmcheck,
} from "@/api/xmcheck.js";
import { getBmxxList, getXmxxList } from "@/api/itWeekly.js";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  computed: {},
  data() {
    return {
      loading: true,
      height: 0,
      ids: [], // 选中数组
      single: true, // 非单个禁用
      multiple: true, // 非多个禁用
      showSearch: true, // 显示搜索条件
      isManage: 0, // 是否管理员
      xmcheckList: [], // 表格数据
      xmxxOptions: [],
      resultOptions: [],
      title: "", // 弹出层标题
      open: false, // 是否显示弹出层
      isnull: false,
      bmList: [],
      xmList: [],
      queryParams: {
        // 查询参数
        db: "dn0",
        tjnf: moment().format("YYYY"),
        bmbh: "",
        xmbh: "",
        zbName: "",
        reviewResult: "",
      },
      params: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        xmlx: "DS", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        xmzt: null, //合同状态，多个,隔开，如1,3
      },
      //   新增编辑表单提交参数
      form: {}, // 表单参数
      rules: {
        // 表单校验
      },
    };
  },
  created() {
    getDictData("xmcheck_review_result", "1").then((res) => {
      if (res.code === 0) {
        this.resultOptions = res.data;
      }
    });
    getBmxxList(this.params.type, this.params.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        this.queryParams.bmbh = this.bmList[0].bmbh;

        getXmxxList(
          this.params.xmlx,
          this.params.range,
          this.params.xmzt,
          this.queryParams.bmbh
        ).then((res) => {
          if (res.code == 0) {
            this.xmList = res.data;
            this.queryParams.xmbh = this.xmList[0].xmbh;
          }
        });
      }
    });
    // getXmxxList().then((res) => {
    //   if (res.code === 0) {
    //     this.xmxxOptions = res.data;
    //     if (res.data.length > 0) {
    //       this.queryParams.xmbh = this.xmxxOptions[0].xmbh;
    //       this.getList();
    //     } else {
    //       this.loading = false;
    //       this.isnull = true;
    //     }
    //   }
    // });
  },
  methods: {
    /** 查询模板列表 */
    getList() {
      this.loading = true;
      getXmchecklist(this.queryParams).then((response) => {
        const docH = document.documentElement.clientHeight;
        const mycontainerH =
          document.querySelector(".mycontainer").clientHeight;
        this.height = docH - mycontainerH - 30;
        if (response.code === 0) {
          this.xmcheckList = response.data;
          this.loading = false;
        } else {
          this.$message({
            showClose: true,
            message: response.msg,
            type: "error",
            duration: 2000,
            center: true,
          });
        }
      });
    },
    handleChangeBm(i) {
      this.queryParams.bmbh = i;
      this.queryParams.bmmc = i;
      getXmxxList(
        this.params.xmlx,
        this.params.range,
        this.params.xmzt,
        i,
        2
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          this.queryParams.xmbh = this.xmList[0].xmbh;
        }
      });
    },
    //导出
    handleExport() {
      if (!this.queryParams.xmbh) {
        this.$message({
          type: "error",
          message: "请选择要导出的项目!",
        });
        return;
      }
      excelExport(this.queryParams).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    /** 重置 */
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      if (!this.queryParams.bmbh) {
        this.$message({
          type: "error",
          message: "请选择部门!",
        });
        return;
      }
      if (!this.queryParams.xmbh) {
        this.$message({
          type: "error",
          message: "请选择查询的项目!",
        });
        return;
      }
      this.getList();
    },

    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const reviewId = row.reviewId;
      getXmcheck(reviewId).then((res) => {
        this.form = res.data;
        this.open = true;
        this.title = "编辑";
      });
    },

    /** 提交按钮 */
    submitForm: function () {
      updateXmcheck(this.form).then((response) => {
        if (response.code == 0) {
          this.$notify({
            title: "成功",
            message: response.msg,
            type: "success",
            duration: 2000,
          });
          this.open = false;
          this.getList();
          this.reset();
        } else {
          this.$message({
            type: "info",
            message: response.msg,
            showClose: true,
          });
        }
      });
    },

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },

    // 表单重置
    reset() {
      this.form = {
        zbId: undefined,
        reviewId: undefined,
        group: undefined,
        type: undefined,
        zbStandard: undefined,
        zp: undefined,
        zpDescribe: undefined,
        fxcxj: undefined,
        fxcxjDescribe: undefined,
        xcxj: undefined,
        xcxjDescribe: undefined,
        bz: undefined,
      };
      this.resetForm("form");
    },

    /** 重置 */
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  padding: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 0;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  padding-bottom: 0;
}
.filter-container {
  padding: 0;
}
.search-container {
  border: 0;
}
::v-deep #dic-form .el-form-item {
  margin-bottom: 0;
}
.el-form-item {
  margin-bottom: 22px;
}
</style>
